import Loader from "../../../../Layouts/Loader/Loader";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import { UserAssignmentUI } from "../../AssignUserToApplication";

const UserAssignmentModal = ({ isOpen, onClose, isLoading, assignedUsers, onAssign, onRemove, fetchSearchResults }) => {
  return (
    <BuilderModal isOpen={isOpen} onClose={onClose} bodyStyle={{ height: "70vh" }} modalName="Assign Users">
      {isLoading ? (
        <div className="assign_loader_overlay">
          <Loader />
        </div>
      ) : (
        <UserAssignmentUI
          assignedUsers={assignedUsers}
          onAssign={onAssign}
          onRemove={onRemove}
          fetchSearchResults={fetchSearchResults}
        />
      )}
    </BuilderModal>
  );
};

export default UserAssignmentModal;
